"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onboardingContractReducer = exports.initialOnboardingContractState = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var hydrate_1 = require("../hydrate");
var utils_1 = require("../utils");
var actions_1 = require("./actions");
exports.initialOnboardingContractState = {
    contracts: [],
    haveOnboardingContractsBeenRequested: false,
    haveSignedOnboardingContractsBeenRequested: false,
    signedContracts: [],
};
exports.onboardingContractReducer = (0, typesafe_actions_1.createReducer)(exports.initialOnboardingContractState)
    .handleAction(actions_1.getAllOnboardingContractsAction.success, function (state, _a) {
    var payload = _a.payload;
    return __assign(__assign({}, state), { contracts: payload, haveOnboardingContractsBeenRequested: true });
})
    .handleAction(actions_1.getSignedOnboardingContractsAction.success, function (state, _a) {
    var payload = _a.payload;
    return __assign(__assign({}, state), { haveSignedOnboardingContractsBeenRequested: true, signedContracts: payload });
})
    .handleAction(actions_1.signOnboardingContractsAction.success, function (state, _a) {
    var payload = _a.payload;
    return __assign(__assign({}, state), { haveSignedOnboardingContractsBeenRequested: true, signedContracts: __spreadArray(__spreadArray([], state.signedContracts, true), [payload], false) });
})
    .handleAction(hydrate_1.nextHydrate, function (state, _a) {
    var onboardingContract = _a.payload.onboardingContract;
    return (__assign(__assign({}, state), (0, utils_1.reconcileState)(onboardingContract, exports.initialOnboardingContractState)));
});
